module.exports = __webpack_public_path__ + "static/feather-logo-74463764e2a6532f8289780f9ead2f92.png";